export default {
  data() {
    return {
      langList: [
        {
          text: "한국어",
          value: "ko",
          func: () => this.langChange("ko")
        },
        {
          text: "English",
          value: "en",
          func: () => this.langChange("en")
        },
        {
          text: "中文",
          value: "ch",
          func: () => this.langChange("ch")
        },
        {
          text: "日本",
          value: "ja",
          func: () => this.langChange("ja")
        },
        {
          text: "Português",
          value: "pr",
          func: () => this.langChange("pr")
        },
        {
          text: "Español",
          value: 'es',
          func: () => this.langChange("es")
        },

      ]
    };
  },
  methods: {
    langChange(lang) {
      this.$i18n.locale = lang;
      this.$store.commit("langChange", lang);
    }
  }
};
